module.exports = __webpack_public_path__ + "media/golf_course.503309db.jpg";